<template>
  <div>
    <b-modal id="modalItems" data-backdrop="static" data-keyboard="false" size="xl" v-model="exibirItens" centered
      :title="this.$t('OS Preventivas à Vencer')">

      <b-table striped hover :items="arrayPlacas" :fields="fields" sticky-header="true">
        <template #cell(ACAO)="row">
          <div v-if="row.item.NR_SEQ_OS">
            <router-link :to="'os/' + row.item.NR_SEQ_OS" size="sm" class="mr-2 btn btn-success" style="padding: 0.25rem 0.5rem;
            font-size: 0.875rem;">
              {{ $t('Acessar OS') }}
            </router-link>
          </div>
          <div v-if="!row.item.NR_SEQ_OS">
            <b-button @click="gerarOs(row.item)" size="sm" class="mr-2">
              {{ $t('Gerar OS') }}
            </b-button>
          </div>
        </template>
      </b-table>

      <template #modal-footer>
        <div class="w-100">
          <div class="row center" style="justify-content: center; ">
            <b-button class="mr-2" variant="danger" size="lg" @click="$emit('showModalaVencer')">
              {{ $t('Fechar') }}
            </b-button>
          </div>
        </div>
      </template>
    </b-modal>
    <modal-fornecedores v-if="showModalFornec" :os="osFicticia" @saveFornec="enviaOsPreventivaExterna"
      @showModalFornec="showModalFornec = false"></modal-fornecedores>
  </div>
</template>
<script>
import ModalFornecedores from './ModalFornecedores.vue'

export default {
  name: 'ModalItems',
  props: {
    os: {},
    item: {}
  },
  data() {
    return {
      selectServico: '',
      obsExterna: '',
      exibirItens: true,
      idConjunto: '',
      countPecas: 1,
      disabledPeca: true,
      fields: [
       { key: 'ACAO', label: this.$t('ACAO') },
       { key: 'PLACA', label: this.$t('PLACA') },
       { key: 'PROXIMO_CICLO', label: this.$t('PROXIMO_CICLO') },
       { key: 'VENCIMENTO', label: this.$t('VENCIMENTO') },
       { key: 'PROXIMO_KM', label: this.$t('PROXIMO_KM') },
       { key: 'KM_ATUAL', label: this.$t('KM_ATUAL') },
       { key: 'CONTRATO_CONCESSIONARIA', label: this.$t('CONTRATO_CONCESSIONARIA') },  
      ],
      arrayPlacas: [],
      showModalFornec: false,
      objValuesOS: {},
      osFicticia: {
        nr_sequencial: 0
      }
    }
  },
  components: {
    ModalFornecedores
  },
  methods: {
    enviaOsPreventivaExterna(nr_os, nr_seq_fornecedor) {
      const cdClifor = this.$store.getters['filial/filial']

      if (nr_seq_fornecedor == undefined) {
        this.$swal.fire({
          title: 'Oops',
          text: 'Selecione um fornecedor!',
          icon: 'warning'
        })
        return false
      }

      const ordemServico = {
        nr_seq_fornecedor: nr_seq_fornecedor,
        placa: this.objValuesOS.PLACA,
        cdProxCiclo: this.objValuesOS.CD_PROX_CICLO,
        cdClifor: cdClifor.tecnicoId,
        cd_prox_ordem:  this.objValuesOS.CD_PROX_ORDEM
      }

      this.$store.dispatch('osItem/gerarPreventiva', { data: ordemServico }).then(() => {
        this.$emit('showModalVencidas')
        window.location.reload()
        this.$emit('refresh')
        this.$swal.fire({
          title: this.$t('Sucesso'),
          text: this.$t('Ordem gerada com sucesso'),
          icon: 'success'
        })
      })
    },

    gerarOs(value) {
      const cdClifor = this.$store.getters['filial/filial']

      this.$swal.fire({
        title: 'Qual é o tipo de OS?',
        text: 'Você deseja direcionar esta OS como externa ou como interna?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Interna',
        confirmButtonText: 'Externa'
      })
        .then(result => {
          if (result.dismiss !== 'backdrop') {
            if (result.value) {
              this.objValuesOS = value
              this.showModalFornec = true
            } else {

              const ordemServico = {
                nr_seq_fornecedor: 23,
                placa: value.PLACA,
                cdProxCiclo: value.CD_PROX_CICLO,
                cdClifor: cdClifor.tecnicoId,                
                cd_prox_ordem: value.CD_PROX_ORDEM
              }

              this.$store.dispatch('osItem/gerarPreventiva', { data: ordemServico }).then(() => {
                this.$emit('showModalaVencer')
                this.$emit('refresh')
                window.location.reload()
                this.$swal.fire({
                  title: this.$t('Sucesso'),
                  text: this.$t('Ordem gerada com sucesso'),
                  icon: 'success'
                })
              })
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },

    getPlacas() {
      this.$store.dispatch('osItem/placasAVencerArmazem', { stPreventiva: 'A' }).then(response => {
        let arrayPlaca = response.data

        arrayPlaca.forEach(placa => {
          const ano = placa.DATA.substring(0, 4)
          const mes = placa.DATA.substring(5, 7)
          const dia = placa.DATA.substring(8, 10)

          var dataAtual = new Date();
          var anoAtual = dataAtual.getFullYear();
          var anoFuturo = anoAtual + 5;

          // const fullData = `${dia}/${mes}/${ano}`
          let fullData = ''

          if(ano < anoFuturo){
            fullData = `${dia}/${mes}/${ano}`
          } 
          
          this.arrayPlacas.push(
            {
              'PLACA': placa.PLACA,
              'PROXIMO_CICLO': placa.PROX_CICLO,
              'VENCIMENTO': fullData,
              'PROXIMO_KM': parseInt(placa.PROXIMO_KM).toLocaleString('pt-BR', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }),
              'KM_ATUAL': parseInt(placa.KM_ATUAL).toLocaleString('pt-BR', { useGrouping: true, minimumFractionDigits: 0, maximumFractionDigits: 0 }),
              'CD_PROX_CICLO': placa.CD_PROX_CICLO,
              'NR_SEQ_OS': placa.NR_SEQ_OS,
              'CD_PROX_ORDEM': placa.CD_PROX_ORDEM,
              'CONTRATO_CONCESSIONARIA': placa.ST_CONCESSIONARIA == 0 ? 'Não' : 'Sim' 
            },
          )
        });
        //console.log(arrayPlaca)
      }).catch(error => {
        console.log(error)
      })
    }
  },
  computed: {
    placas() {
      const placas = this.$store.getters['osItem/placasAVencer']

      if (!placas) {
        this.$store.dispatch('osItem/placasAVencer')

        return []
      }

      return [placas]
    },
    items() {
      return this.$store.getters['osItem/items']
    },
  },

  created() {
    this.getPlacas()
  },
}
</script>
<style scoped>
  #modalItems {
    pointer-events: none !important;
    height: 750px !important;
  }

  .close {
    display: none !important;
  }

  #totalPecas {
    height: 435px !important;
    overflow-x: auto !important;
  }

  .modal-content {
    height: 700px !important;
  }

  .divGerar {
    border: 1px solid #c1c1c1;
  }
</style>